import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AppMaterialModule } from '../../shared/appMaterial/app-material.module';
import { TextMaskModule } from 'angular2-text-mask';
import { SharedModule } from '../../shared/shared.module';
import { CookieStatementRoutingModule } from './cookie-statement-routing.module';
import { CookieStatementComponent } from './cookie-statement.component';
import {
  MatDialogModule,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';

@NgModule({
  imports: [
    CommonModule,
    CookieStatementRoutingModule,
    FormsModule,
    AppMaterialModule,
    SharedModule,
    TextMaskModule,
    MatDialogModule,
  ],
  declarations: [CookieStatementComponent],
  exports: [CookieStatementComponent],
  providers: [
    { provide: MatDialogRef, useValue: {} },
    { provide: MAT_DIALOG_DATA, useValue: [] },
  ],
})
export class CookiesStatementModule {}
